import React, { FC, useCallback, useState } from "react";
import { ButtonProps, Dialog, Input } from "@xapp/components";

import { BasicIntegrationCard, IntegrationCardProp } from "./BasicIntegrationCard";

export interface HousecallProConnectionProps {
    integration: "housecallpro";
    token: string;
}

export interface HousecallProIntegrationCardProps extends IntegrationCardProp {
    token?: string;

    onConnect?(props: HousecallProConnectionProps): void;
}

export const HousecallProIntegrationCard: FC<HousecallProIntegrationCardProps> = (props) => {

    const { checked, disabled, isLinked, isActive, onConnect, onDisconnect } = props;

    const [token, setToken] = useState<string>(props.token || "");
    const [showDialog, setShowDialog] = useState<boolean>(false);

    const handleHousecallProClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
        e.preventDefault();

        if (typeof checked === "boolean") {
            if (typeof props.onClick === "function") {
                props.onClick(e);
            }
        } else {
            // pop up modal
            setShowDialog(true);
        }
    };

    const handleConnectHousecallPro = useCallback(() => {
        if (typeof onConnect === "function") {
            onConnect({ integration: "housecallpro", token });
            setShowDialog(false);
        }
    }, [onConnect, token]);

    const handleDisconnectHousecallPro = useCallback(() => {
        if (typeof onDisconnect === "function") {
            onDisconnect();
        }
    }, [onDisconnect]);

    const actions: ButtonProps[] = [
        {
            label: "Close",
            variation: "secondary",
            onClick: () => { setShowDialog(false) }
        }
    ];

    if (typeof onConnect === "function") {
        actions.push({
            label: "Connect",
            variation: "primary",
            disabled: !token,
            onClick: handleConnectHousecallPro
        })
    }

    return (
        <>
            <BasicIntegrationCard
                checked={checked}
                disabled={disabled}
                imageUrl="/img/integrations/housecall-pro/housecall-pro-logo.png"
                integrationId="housecallpro"
                text="Housecall Pro"
                href={() => "/integrations/housecallpro"}
                onClick={handleHousecallProClick}
                isLinked={isLinked}
                isActive={isActive}
                onDisconnect={typeof onDisconnect === "function" ? handleDisconnectHousecallPro : undefined}
            />
            <Dialog
                active={showDialog}
                actions={actions}
                title="Housecall Pro Setup"
                onClose={() => { setShowDialog(false) }}
            >
                <p>Navigate to the App store within Housecall Pro, select API and generate a new API key with full access.  Paste the key below.</p>
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/* @ts-ignore */}
                <Input label="Housecall Pro API Key" value={token} onChange={setToken} />
                <p>More detailed instructions can be found <a target="_blank" href={"https://documentation.xapp.ai/help/integrations/integration-housecall-pro/#connect-your-housecall-pro-account-to-xapp-ai"} rel="noreferrer">here</a></p>
            </Dialog>
        </>
    );
}